var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "texts-context",
      style: {
        "flex-direction": _vm.direction,
        "font-size":
          String(_vm.fontSize).indexOf("px") === -1
            ? _vm.fontSize + "px"
            : _vm.fontSize,
        "line-height": _vm.direction !== "column" ? "none" : "18px",
      },
    },
    [
      _vm.texts.some(function (item) {
        return !item
      })
        ? _c(
            "span",
            {
              style: {
                "align-items": _vm.align,
                "justify-content": _vm.justify,
              },
            },
            [_vm._v(_vm._s(_vm.nullText ? _vm.nullText : "--"))]
          )
        : _c(
            "span",
            {
              style: { "text-align": _vm.align },
              attrs: { title: _vm.texts.join(".") },
            },
            [_vm._v(_vm._s(_vm.texts.join(".")))]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }